// extracted by mini-css-extract-plugin
export default {"nav":"CvPTd","logo":"mAzvJ","dark":"emeRE"};